export const getDataGridHeight = (maxHeight, currentRowCount) =>
    currentRowCount ? Math.min(128 + currentRowCount * 36, maxHeight) : 160;
